

import { Link } from "react-router-dom"
import {useMediaQuery} from "beautiful-react-hooks";



export default function AppHeader(){

    const isSmall = useMediaQuery('(max-width: 768px)')



    return(

        <>

        {isSmall ? 

        <a href="https://static.sinatether.com/SinaTether-signed-0.0.1.apk" className="css-ja2p96">

            <div className="d-flex2935">

                <div className="d-flex2935">
                    <div className="css-vzdmuh">
                        <img src="https://static.sinatether.com/banner/logo_app.png" className="img2025"/>
                    </div>
                    <div className="css-1ys6r9j ">
                        <div className="css-1w4eqm9">
                            اپلیکیشن سینا تتر

                        </div>

                        <div className="css-1vi9snr">
                            معاملات ایمن تر و سریع تر

                        </div>
                    </div>

                </div>
                <button className="btds2025">

               

دانلود


                </button>
                

            </div>

        </a>



            :



            <div className="header animated slideInDown fixed ">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 pl-0 pr-0">
                        <div className="navigation">
                            <nav className="navbar navbar-expand-lg navbar-light bg-light">

                                        <Link to={'/'}>

                                        <img className={'logo-desk-css'} src={'./images/main-logo.svg'} alt={'سیناتتر'}/>
                                        </Link>

                                

                                <div className="collapse navbar-collapse jfsjnrnn323424" id="navbarNavDropdown">
                                    <ul className="navbar-nav skjdsjf">

                                        <li className="li-width text-center" >
                                        <a href={'/USDT'}>

                                            <div className="jshfswewwrwr1313 ">


                                            معامله سریع



                                            </div>

                                            </a>

                                        </li>

                                        <li className="li-width text-center">
                                        <a href={'/about'} className="jshfswewwrwr1313">

                                        <div className="jshfswewwrwr1313">
                                        درباره ما


                                        </div>
                                        </a>


                                        </li>


                                        <li className="li-width text-center">
                                        <a href={'/prize-exchange'}>

                                        <div className="jshfswewwrwr1313 animate-charcter">

                                            صرافی جایزه دار


                                    </div>
                                    </a>
                                        </li>


                                    </ul>
                                </div>
                                
                                                                                                                                                               
                                

                                <div className="signin-btn ">
                                    <Link to={"/login"}>
                                        
                                        <button className="btn btn-primary text-white mybold jsdhsjhgfg53729342 fkjegrebrerwrw">ورود /  ثبت نام </button>
                                        
                                        </Link>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        }






        
        
        </>
    )
}